import type { ReactNode } from "react";
import { PublicBar } from "@/components/auth/PublicBar";
import { BRAND } from "@/lib/brand";

/** 약관류 문서의 껍데기 , 공개 상단 막대 + 68ch 본문 + 초안 표시 */
export function LegalPage({ title, effective, children }: { title: string; effective: string; children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <PublicBar />
      <main className="mx-auto w-full max-w-legal px-section py-section-wide">
        <p className="note note-warn inline-block text-caption font-semibold">초안(법무 검토 전)</p>
        <h1 className="mt-content text-title font-extrabold tracking-tight text-ink">{title}</h1>
        <p className="mt-label text-caption text-ink-muted">
          시행일 {effective}, {BRAND.ORG}, 운영 {BRAND.DEVELOPER}
        </p>
        <article className="legal legal-doc mt-page">{children}</article>
      </main>
    </div>
  );
}
